import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { isLoggedIn, logout } from '../api/account';
import { navigateToLoginScreen } from '../pages/PageProfile'

export default function ButtonAppBar({setShowNavUser}) {
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const user = isLoggedIn()

  const logoutAction = () => {
   logout()
   window.open(window.location.origin, '_self')
  }

  const goHome = () => { window.open(window.location.origin, '_self') }
  const goToAddStore = () => { window.open(window.location.origin+'?page=addStore', '_self')}
  const goToAddSocialContent = () => { window.open(window.location.origin+'?page=addSocialContent', '_self')}
  const login = () => { navigateToLoginScreen() }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ bgcolor: 'purple', boxShadow: '0 1px 4px rgba(0,0,0,0.2)' }}>
        <Toolbar sx={{ minHeight: '48px !important', px: 2 }}>
          <Typography
            variant="subtitle1"
            component="div"
            sx={{ flexGrow: 1, fontWeight: 600, letterSpacing: '0.05em', fontSize: '1rem' }}
          >
            Where Is My Bus
          </Typography>

          { user ? (
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt={user.name} src="/" sx={{ width: 32, height: 32 }} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '40px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem key='logout' onClick={logoutAction}>
                  <Typography textAlign="center">Logout</Typography>
                </MenuItem>
              </Menu>
            </Box>
          ) : null }
        </Toolbar>
      </AppBar>
    </Box>
  );
}
